import ApiService from '@/services/ApiService';

class MixPanelService {
  static async track({
    event_name,
    extra_info = null,
    contact_id = null,
    property_id = null,
  } = {}) {
    const payload = {
      event_name,
      extra_info,
      contact_id,
      property_id,
    };
    const composedURL = `/api/metrics/track_event/`;
    const response = await ApiService.post(composedURL, payload);
    return response;
  }
}

export default MixPanelService;
